import axiosServices from '../../services/axiosServices.js'

const state = () => ({  
    aIndicadores : [],
    bCargando : false,
    bCargandoConfigGrid : false,
    oPermisos:{               // Contiene la configuracion de la tabla y permisos
        priv_access : '1',
        priv_insert : '1',
        priv_delete : '1',
        priv_update : '1'
    },
    bNuevoIndicador: false, // Indica si se va a generar un nuevo indicador (true)
    nSeleccionado: -1, // Indicador seleccionado (si aplica) indice del array 
    oSeleccionadoEditar: {}, // Indicador seleccionado para editar
    oSeleccionadoEstado: {}, // Indicador seleccionado para activar o inactivar
})

const mutations = {
    SETAINDICADORES:(state, oValue) => {
        if(oValue.estado === 'inicial') state.bCargando= true
        axiosServices.getConfiguration("/indicadores/menu", true, oValue.params).then((reponse) => {
            state.aIndicadores = reponse.aData
            state.bCargando = false
        })
    },
    SETBCARGANDO: (state ) => {
        state.bCargando = true
    },
    SETAPERMISOS: (state, oValue) => {
        state
        oValue
    //   state.bCargandoConfigGrid= true
    //   axiosServices.getConfiguration('/pGrids_info', true, oValue).then((response) =>{
    //     state.oPermisos = response.aData.oConfiguracion.permisos
    //     state.bCargandoConfigGrid = false
    //   })
    },
    SAVE_NUEVO_INDICADOR: (state, value) => {
        state.bNuevoIndicador = value
    },
    SAVE_SELECCIONADO: (state, value) => {
        state.nSeleccionado = value
    },
    SAVE_SELECCIONADO_EDITAR: (state, value) => {
        state.oSeleccionadoEditar = value
    },
    SAVE_SELECCIONADO_ESTADO: (state, value) => {
        state.oSeleccionadoEstado = value
    }
}
const actions = {
    setAIndicadores({ commit }, value){
        commit('SETAINDICADORES', value)
    },
    setBCargando ({ commit }) {
        commit('SETBCARGANDO') 
    },
    setAPermisos({ commit }, value){
        commit('SETAPERMISOS', value)
    },
    save_nuevo_indicador({commit}, value) {
        commit('SAVE_NUEVO_INDICADOR', value)
    },
    save_seleccionado({commit}, value) {
        commit('SAVE_SELECCIONADO', value)
    },
    save_seleccionadoEditar({commit}, value) {
        commit('SAVE_SELECCIONADO_EDITAR', value)
    },
    save_seleccionadoEstado({commit}, value) {
        commit('SAVE_SELECCIONADO_ESTADO', value)
    }
}
const getters = {
    getAIndicadores: (state) => {
        return state.aIndicadores
    },
    getBCargando: (state) => {
        return state.bCargando
    },
    getBCargandoConfigGrid: (state) => {
      return state.bCargandoConfigGrid
    },
    getAPermisos: (state) => {
        return state.oPermisos
    },
    getNuevoIndicador: (state) => {
        return state.bNuevoIndicador
    },
    getSeleccionado: (state) => {
        return state.nSeleccionado
    },
    getSeleccionadoEditar: (state) => {
        return state.oSeleccionadoEditar
    },
    getSeleccionadoEstado: (state) => {
        return state.oSeleccionadoEstado
    }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}